import React from 'react';
import MaskedInput from 'react-text-mask';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';

class MaskedInputCustom extends React.Component {
    render() {
        const { inputRef, ...rest } = this.props;
        return <MaskedInput ref={(ref) => inputRef(ref ? ref.inputElement : null)} {...rest} />;
    }
}

class MaskedTextField extends React.Component {
    render() {
        const { id, label, labelClasses, error, onBlur, ...rest } = this.props;
        return (
            <FormControl variant="outlined" margin="dense" error={error}>
                <InputLabel htmlFor={id} classes={labelClasses}>
                    {label}
                </InputLabel>
                <OutlinedInput
                    label={label}
                    id={id}
                    name={id}
                    onBlur={onBlur}
                    {...rest}
                    inputComponent={MaskedInputCustom}
                    inputProps={rest}
                />
            </FormControl>
        );
    }
}

export default MaskedTextField;
